import React, { useState } from "react";
import moment from "moment";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-flatpickr components
import Flatpickr from "react-flatpickr";

// react-flatpickr styles
import "flatpickr/dist/flatpickr.css";

// Material Kit 2 React components
import MKInput from "components/MKInput";

export default function MKDatePicker({
  name = "",
  valueType = "",
  onDateChange,
  input,
  label,
  ...rest
}) {
  const [value, setValue] = useState(valueType);

  const handleChange = (event) => {
    onDateChange({
      name: name,
      value: moment(event[0]).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
    });
  };

  return (
    <Flatpickr
      {...rest}
      render={({ defaultValue }, ref) => (
        <MKInput
          {...input}
          defaultValue={defaultValue}
          inputRef={ref}
          label={label}
          variant="outlined"
          fullWidth
          focused
          margin="normal"
        />
      )}
      options={{ dateFormat: "d-M-Y" }}
      value={value}
      onChange={(newValue) => handleChange(newValue)}
    />
  );
}

// Setting default values for the props of MKDatePicker
MKDatePicker.defaultProps = {
  input: {},
};

// Typechecking props for the MKDatePicker
MKDatePicker.propTypes = {
  input: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.any])),
};
